module.exports = __webpack_public_path__ + "static/fanbase-logo-07555a76d6ed672a2fa15d0a84371553.png";